var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vue-turnstile',{attrs:{"site-key":_vm.siteKey,"size":"normal","theme":"auto","retry":"never","auto-reset":false},on:{"verified":_vm.onVerify,"error-callback":_vm.onFail,"expired-callback":_vm.onFail,"timeout-callback":_vm.onFail},model:{value:(_vm.token),callback:function ($$v) {_vm.token=$$v},expression:"token"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }